/** Shared list for field trial network filters and trial detail labels. */
export const PHENOLOGY_OPTIONS = [
    {
        value: '',
        label: {
            es: 'Desconocido',
            en: 'Unknown',
            pt: 'Desconhecida',
        },
    },
    {
        value: 'emergence',
        label: {
            es: 'Emergencia',
            en: 'Emergence',
            pt: 'Emergência',
        },
    },
    {
        value: 'vegetative',
        label: {
            es: 'Vegetativo',
            en: 'Vegetative',
            pt: 'Vegetativo',
        },
    },
    {
        value: 'reproductive',
        label: {
            es: 'Reproductivo',
            en: 'Reproductive',
            pt: 'Reproductivo',
        },
    },
    {
        value: 'preharvest',
        label: {
            es: 'Madurez fisiológica',
            en: 'Physiological maturity',
            pt: 'Maturidade fisiológica',
        },
    },
];
